(function () {
	'use strict';
	var $ = window.jQuery;

	function Neutralized(options) {
		if (!options) {
			throw new Error('No options passed to Neutralized constructor');
		}

		this.options = $.extend({}, Neutralized.defaults, options);

		if ($('.neutralized_page, .renewal_page, .ticket_central_page').length) {
			this.initStickyHeader();
			this.initMobileHeaderNav();
			this.initSubHeaderNav();
			this.initAnchorLinks();
		}
	}

	Neutralized.prototype.initStickyHeader = function () {
		var $headerSelector = $(this.options.headerContainer),
			$offset = 0;

		if ($('body').hasClass('admin-bar')) {
			if ($(window).width() <= 992) {
				$offset = 46;
			} else {
				$offset = 32;
			}
		}

		if ($headerSelector.length) {
			// Sticky Header
			new window.Waypoint.Sticky({
				element: $headerSelector[0],
				stuckClass: 'fixed',
				offset: $offset,
			});
		}
	};

	Neutralized.prototype.initMobileHeaderNav = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb');

		$mobileHamburger.click(function (e) {
			e.preventDefault();

			$(this).toggleClass('open');

			if ($headerNavSelector.hasClass('opened')) {
				$bodySelector.removeClass('mobile-menu-opened');
				$headerNavSelector.removeClass('opened');
				$headerNavSelector.find('.submenu').removeClass('opened');
				$headerNavSelector.find('> ul > li').removeClass('opened');
			} else {
				$bodySelector.addClass('mobile-menu-opened');
				$headerNavSelector.addClass('opened');
			}
		});

		$(window).resize(function () {
			$mobileHamburger.removeClass('open');
			$bodySelector.removeClass('mobile-menu-opened');
			$headerNavSelector.removeClass('opened');
			$('li.has-dropdown > a').removeClass('active');
			$headerNavSelector.find('.submenu').removeClass('opened');
			$headerNavSelector.find('> ul > li').removeClass('opened');
		});
	};

	Neutralized.prototype.initSubHeaderNav = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$headerSubnavLink = $headerNavSelector.find('li.has-dropdown');

		if($(window).width() > 992) {
			$headerSubnavLink.hover(function () {
				if ($(this).find('.submenu').length) {
					if ($(this).find('.submenu').hasClass('opened')) {
						$(this).removeClass('opened');
						$(this).find('.submenu').removeClass('opened').stop().slideUp(200);
					} else {
						$headerNavSelector.find('.submenu').removeClass('opened');
						$headerNavSelector.find('> ul > li').removeClass('opened');
						$(this).addClass('opened');
						$(this).find('.submenu').addClass('opened').stop().slideDown(200);
					}
				}
			});
		} else {
			$headerNavSelector.find('> ul > li > a').click(function (e) {
				if ($(this).parent().find('.submenu').length) {
					e.preventDefault();

					if ($(this).parent().find('.submenu').hasClass('opened')) {
						$(this).parent().removeClass('opened');
						$(this).parent().find('.submenu').removeClass('opened');
					} else {
						$headerNavSelector.find('.submenu').removeClass('opened');
						$headerNavSelector.find('> ul > li').removeClass('opened');
						$(this).parent().addClass('opened');
						$(this).parent().find('.submenu').addClass('opened');
					}
				}
			});
		}
	};

	Neutralized.prototype.initAnchorLinks = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb');

		$('a[href*="#"]:not([href="#"])').click(function() {
			if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
				var target = $(this.hash),
					offset = 85;
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if ($(window).width() < 1200) {
					offset = 70;
				}
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top - offset,
					}, 1000);

					$mobileHamburger.removeClass('open');
					$bodySelector.removeClass('mobile-menu-opened');
					$headerNavSelector.removeClass('opened');
					$('li.has-dropdown > a').removeClass('active');
					return false;
				}
			}
		});
	};

	Neutralized.defaults = {
		headerNavSelector: '.neutralized_page .header__nav, .renewal_page .header__nav, .ticket_central_page .header__nav',
		headerContainer: '.neutralized_page .header, .renewal_page .header, .ticket_central_page .header',
	};

	window.Neutralized = Neutralized;
}());
